const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    body: {
      type: 'string',
      title: 'متن پیام',

    },
  },
});

export default schema;
